import { Grid } from "@material-ui/core"
import { Box, Button, Checkbox, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { CustomPaper } from "../../../../../../../../components/CustomPaper"
import { LoadingButton } from "@mui/lab"
import { CustomTable } from "../../../../../../../../components"
import { useStyles } from "./styles"
import { UsersProps } from "./types"
import { DrawerSettings } from "../drawerSettings"
import { useEffect, useMemo, useState } from "react"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import Loader from "../../../../../../../../components/loader"
import { channelSending } from "../../utils/constans/constans"
import { ChannelSend } from "../../utils/enums/tabs"



export const Users = (props: UsersProps) => {
const {checks, setChecks} = props
  const { t } = useTranslation()
  const styles = useStyles()

  const [modal, setModal] = useState<{
    open: boolean
    title: string
    description: string
    confirm: () => void
    cancel?: () => void
  }>({
    open: false,
    title: '',
    description: '',
    confirm: () => { }
  })

  const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

  const searchUsers = () => {
    if (!props.selectedUsers?.length) {
      props.searchButton.onClick({email:checks[1],app:checks[2]})
    } else {
      setModal(prev => ({
        ...prev,
        open: true,
        title: t("general.userFilterWarningTitle"),
        description: t("general.userFilterWarningDescription"),
        cancel: closeModal,
        confirm: () => {
          props.searchButton.onClick({email:checks[1],app:checks[2]})
          props.setSelectedUsers([])
          /* resetData({ loadSuccess: true }) */
          closeModal()
        }
      }))
    }
  }

  const channelOptions = useMemo(() => channelSending(t), [t]);

  const filteredData = props.row/* ?.filter((item) => {
    const filterByEmail = checks[ChannelSend.EMAIL] ? item.email : true;

    const filterByApp = checks[ChannelSend.APP] ? item.app : true;

    return filterByEmail && filterByApp;
  }); */

  const handleChannelChecks = (channel: ChannelSend) => {
    setChecks((prevChecks) => ({
      ...prevChecks,
      [channel]: !prevChecks[channel],
    }));

    props.searchButton.onClick({email: channel == ChannelSend.EMAIL ? !checks[1] : checks[1], app: channel == ChannelSend.APP ? !checks[2] :  checks[2]})
  };

  return (
    <Grid container sx={{ height: '100%' }} spacing={3}>
      <Grid item /* sx={[styles.modalContent({ open: true })]} */ xl={4} lg={4} md={12} sm={12} xs={12} >
        <CustomPaper elevation={2} sx={{ height: '100%' }}>
          <Typography sx={[styles.createTitle,]} fontWeight={'bold'}>{t('Questionarie.permissions.searchForUsers')}</Typography>

          <Box sx={styles.contentRight}>
            <Box sx={styles.content}>
              {props.rigthItem}
            </Box>

            <Box sx={styles.footerBtn}>
              <Button onClick={props.cleanFilter} variant="text">{t('general.cleanFilters')}</Button>

              <LoadingButton loading={!!props.searchButton.loading} onClick={() => { searchUsers() }} variant='contained'>{t("general.searchUsers")}</LoadingButton>
            </Box>
          </Box>

          <SimpleModal
            open={modal.open}
            close={() => { closeModal() }}
            removeClose={!modal?.cancel}
            title={modal.title}
            description={modal.description}
            buttonText={t('general.confirm')}
            cancelText={t('general.cancel')}
            back={modal?.cancel ?? undefined}
            next={modal.confirm ?? closeModal}
          />
        </CustomPaper>
      </Grid>

      <Grid item xl={8} lg={8} md={12} sm={12} xs={12} >
        <CustomPaper elevation={2} sx={{ height: '100%' }}>
          <Box sx={styles.saveButton}>
            {channelOptions.map(option => (
              <Box key={option.id} sx={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  className='remove-m'
                  name="channel"
                  checked={checks[option.value as unknown as ChannelSend]}
                  onChange={() => {
                    handleChannelChecks(option.value as unknown as ChannelSend)
                  }}
                  sx={styles.checkBox}
                />
                <Typography sx={styles.drawerTitle}>{option.label}</Typography>
              </Box>
            ))}

            <Box>
              <LoadingButton
                onClick={() => { props.handleSubmitUser(); }}
                disabled={props.disabledButton}
                variant="contained"
                loading={props.loading}
              >
                {t('general.save')}
              </LoadingButton>
            </Box>
          </Box>

          <Box sx={styles.permissionTable({ loading: !!props.searchButton?.loading })}>
            {
              !!props.searchButton.loading || !!props.loadData.loading ? <Loader /> : (
                <CustomTable
                  tableChecks
                  defaultChecks={props.selectedUsers}
                  onClick={(payload) => {
                    props.setSelectedUsers(payload?.checks ?? [])
                  }}
                  name="Informe General"
                  dontRefresh
                  column={props.column}
                  row={filteredData ?? []}
                  selected={-1}
                />
              )
            }
          </Box>
        </CustomPaper>
      </Grid>

      <DrawerSettings
        loadData={props.loadData}
        openDrawer={props.openDrawer}
        closeDrawer={props.closeDrawer}
        close={props.close}
        setSelectedUsers={props.setSelectedUsers}
      />
    </Grid>
  )
}
